import * as types from 'model/actionTypes'
import { AccountT } from 'model/types'

export function receiveAccount (account: AccountT) {
  return {
    type: types.RECEIVE_ACCOUNT,
    account
  }
}
